<template>
  <div ref="container" :style="'--is-login:' + isLogin">
    <Transition name="slide-fade">
      <div v-if="isSuccessUpdate" class="badge-status d-flex align-items-center gap-2">
        <div class="icon-check">
          <img :src="check" alt="">
        </div>
        <span>Berhasil perbarui status</span>
      </div>
    </Transition>
    <AppHeader />
    <SideNav />
    <div class="content-wrapper">
      <slot />
    </div>
    <!-- <div v-show="isActive" class="rotate-info d-sm-none" style="z-index: 9">
      <div class="d-flex align-items-center">
        <i class="apo-rotate text-xxxlg me-2" />
        <div>
          Ingin tampilan lebih luas? Silahkan putar device menjadi landscape
        </div>
      </div>
      <button
        type="button"
        class="btn btn-link text-white p-0"
        @click="toggleHide"
      >
        <i class="bi bi-x-lg text-lg" />
      </button>
    </div> -->
    <!-- <AppFooter :legal-items="pageData?.legalItems" /> -->
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import check from '~/assets/images/check-toast.png'

const  { isSuccessUpdate } = useUpdateBadge()
// const isActive = ref(true);

// function toggleHide() {
//   isActive.value = !isActive.value;
// }

const isLogin = ref('none')
</script>

<style scoped lang="scss">
.content-wrapper {
  position: relative;
  display: flex;
  transition-duration: 0.2s;
}

.badge-status {
  position: fixed;
  top: 20px;
  right: 15px;
  z-index: 9999;
  background-color: #00A993;
  color: white;
  padding: 12px 16px; 
  border-radius: 12px; 
  width: auto; 
  min-width: 250px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);

  .icon-check {
    color: #00A993; 
    width: 15px;
    height: 15px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    flex-shrink: 0;
  }

  span {
    font-weight: 500;
    font-size: 14px;
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

@media (max-width: 1024px) {
  .side-nav-wrapper {
    &.collapsed ~ .content-wrapper {
      margin-left: 0;
    }
  }
  .content-wrapper {
    margin-left: 0;
    margin-top: 64px;
    height: 100%;
  }
  .rotate-info {
    position: fixed;
    background-color: $dark;
    bottom: 28px;
    left: 50%;
    color: $neutral-10;
    width: calc(100% - 40px);
    transform: translateX(-50%);
    padding: 8px 12px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
  }
}
</style>
